/**
 * 创建XMLHttpRequest对象，兼容IE8+
 * @returns {XMLHttpRequest|ActiveXObject}
 */
function createXHR() {
  var xhr = null;
  try {
    // 现代浏览器
    xhr = new XMLHttpRequest();
  } catch (e) {
    // IE8及以下版本
    try {
      xhr = new ActiveXObject('Microsoft.XMLHTTP');
    } catch (e2) {
      try {
        xhr = new ActiveXObject('Msxml2.XMLHTTP');
      } catch (e3) {
        throw new Error('浏览器不支持XMLHttpRequest对象');
      }
    }
  }
  return xhr;
}

/**
 * 对象属性扩展
 * @param {Object} target 目标对象
 * @param {Object} source 源对象
 * @returns {Object}
 */
function extend(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * 序列化对象为URL参数字符串
 * @param {Object} obj 要序列化的对象
 * @returns {String}
 */
function serialize(obj) {
  if (!obj || typeof obj !== 'object') {
    return '';
  }
  
  var pairs = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
  }
  return pairs.join('&');
}

/**
 * 解析JSON字符串，兼容IE8
 * @param {String} str JSON字符串
 * @returns {Object|null}
 */
function parseJSON(str) {
  if (!str || typeof str !== 'string') {
    return null;
  }
  
  try {
    // 现代浏览器
    if (typeof JSON !== 'undefined' && JSON.parse) {
      return JSON.parse(str);
    }
    // IE8 fallback
    return (new Function('return ' + str))();
  } catch (e) {
    console.error('JSON解析失败:', e);
    return null;
  }
}

/**
 * 字符串化对象为JSON，兼容IE8
 * @param {Object} obj 要字符串化的对象
 * @returns {String}
 */
function stringifyJSON(obj) {
  if (typeof JSON !== 'undefined' && JSON.stringify) {
    return JSON.stringify(obj);
  }
  
  // IE8 fallback - 简单实现
  if (obj === null) return 'null';
  if (typeof obj === 'undefined') return 'undefined';
  if (typeof obj === 'string') return '"' + obj.replace(/"/g, '\\"') + '"';
  if (typeof obj === 'number' || typeof obj === 'boolean') return String(obj);
  
  if (obj instanceof Array) {
    var arr = [];
    for (var i = 0; i < obj.length; i++) {
      arr.push(stringifyJSON(obj[i]));
    }
    return '[' + arr.join(',') + ']';
  }
  
  if (typeof obj === 'object') {
    var pairs = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        pairs.push('"' + key + '":' + stringifyJSON(obj[key]));
      }
    }
    return '{' + pairs.join(',') + '}';
  }
  
  return '{}';
}

/**
 * Ajax请求默认配置
 */
var defaultOptions = {
  method: 'GET',
  url: '',
  data: null,
  headers: {},
  timeout: 30000,
  async: true,
  contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
  dataType: 'json',
  withCredentials: false,
  success: function() {},
  error: function() {},
  complete: function() {},
  beforeSend: function() {}
};

/**
 * Ajax核心函数
 * @param {Object} options 请求配置选项
 * @returns {XMLHttpRequest}
 */
function ajax(options) {
  // 参数验证
  if (!options || typeof options !== 'object') {
    throw new Error('Ajax参数必须是一个对象');
  }
  
  if (!options.url) {
    throw new Error('请求URL不能为空');
  }

  // 合并默认配置
  var config = extend({}, defaultOptions);
  config = extend(config, options);
  
  // 标准化请求方法
  config.method = config.method.toUpperCase();
  
  var xhr = createXHR();
  var isTimeout = false;
  var timer = null;

  // 设置超时处理
  if (config.timeout > 0) {
    timer = setTimeout(function() {
      isTimeout = true;
      xhr.abort();
      config.error.call(xhr, {
        status: 0,
        statusText: 'timeout',
        message: '请求超时'
      }, xhr);
      config.complete.call(xhr, xhr);
    }, config.timeout);
  }

  // 处理请求数据
  var requestData = null;
  var url = config.url;
  
  if (config.data) {
    if (config.method === 'GET' || config.method === 'DELETE') {
      // GET和DELETE请求将数据添加到URL
      var separator = url.indexOf('?') > -1 ? '&' : '?';
      url += separator + serialize(config.data);
    } else {
      // POST和PUT请求
      if (config.contentType.indexOf('application/json') > -1) {
        requestData = stringifyJSON(config.data);
      } else {
        requestData = serialize(config.data);
      }
    }
  }

  // 状态变化处理
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if (timer) {
        clearTimeout(timer);
      }
      
      if (isTimeout) {
        return;
      }

      var response = {
        status: xhr.status,
        statusText: xhr.statusText,
        responseText: xhr.responseText,
        responseXML: xhr.responseXML,
        data: null
      };

      // 解析响应数据
      if (xhr.responseText) {
        if (config.dataType === 'json') {
          response.data = parseJSON(xhr.responseText);
        } else if (config.dataType === 'xml') {
          response.data = xhr.responseXML;
        } else {
          response.data = xhr.responseText;
        }
      }

      // 判断请求是否成功
      if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
        config.success.call(xhr, response.data, xhr, response);
      } else {
        config.error.call(xhr, {
          status: xhr.status,
          statusText: xhr.statusText,
          message: '请求失败: ' + xhr.status + ' ' + xhr.statusText
        }, xhr);
      }
      
      config.complete.call(xhr, xhr);
    }
  };

  // 打开连接
  xhr.open(config.method, url, config.async);

  // 设置请求头
  if (config.method !== 'GET') {
    xhr.setRequestHeader('Content-Type', config.contentType);
  }
  
  // 设置自定义请求头
  for (var header in config.headers) {
    if (config.headers.hasOwnProperty(header)) {
      xhr.setRequestHeader(header, config.headers[header]);
    }
  }

  // 设置跨域凭证
  if (config.withCredentials && xhr.withCredentials !== undefined) {
    xhr.withCredentials = true;
  }

  // 请求前回调
  if (config.beforeSend.call(xhr, xhr, config) === false) {
    return xhr;
  }

  // 发送请求
  try {
    xhr.send(requestData);
  } catch (e) {
    config.error.call(xhr, {
      status: 0,
      statusText: 'error',
      message: '发送请求失败: ' + e?.message
    }, xhr);
  }

  return xhr;
}

// ES6 模块导出
export default ajax;